import { useMemo } from "react";
import QuizEngine from "@/components/games/QuizEngine";

function rnd(n) {
  return Math.floor(Math.random() * n);
}
function shuffle(a) {
  const arr = [...a];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function NumberChallenge({ onFinish, difficulty = "easy" }) {
  const questions = useMemo(() => {
    const range = difficulty === "hard" ? 50 : difficulty === "medium" ? 20 : 10;
    const allowSub = difficulty !== "easy";
    const out = [];
    for (let i = 0; i < 10; i++) {
      let a = 1 + rnd(range);
      let b = 1 + rnd(range);
      const sub = allowSub && Math.random() > 0.5;
      if (sub && b > a) [a, b] = [b, a];
      const ans = sub ? a - b : a + b;
      const opts = new Set([ans]);
      while (opts.size < 4) {
        const delta = 1 + rnd(5);
        opts.add(Math.max(0, ans + (Math.random() > 0.5 ? delta : -delta)));
      }
      const options = shuffle([...opts]);
      out.push({
        prompt: `${a} ${sub ? "−" : "+"} ${b} = ?`,
        options: options.map(String),
        answer: options.indexOf(ans),
      });
    }
    return out;
  }, [difficulty]);
  return <QuizEngine questions={questions} onFinish={onFinish} />;
}
